<template>
    <div>



        <PageTitle v-bind:title="title" v-bind:admin="false" />

        <TheCoursesMenu v-bind:index=1 />

        <!--
        <div class="section mt-4">
            <div class="row">
                <div class="col-lg-2">
                </div>
                <div class="col-lg-8">
                    <div class="card shadow p-3">
                        <div class="row">
                            <div class="col-2 d-flex">
                                <img src="/images/grapes.svg" class="rounded float-left" style="width: 100%;" alt="">
                            </div>
                            <div class="col-10">
                                Какая-нибудь мотивирующая надпись, или чья-нибудь цитата. Ну или что-нибудь ещё.
                            </div>           
                        </div>
                    </div>
                </div>
                <div class="col-lg-2">
                </div>
            </div>     
        </div>
        -->

        <QuoteTest />





        <template v-if="data.lastAdded">
            <h2 class="mt-4 mb-4">Последние добавленные Курсы:</h2>
            <CoursesSlider1 v-bind:courses="data.lastAdded" />
        </template>
        <!-- <h1>!!!!!{{ this.$route.query.department }}</h1> -->

        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>
        <h2 class="mt-4">Полный список Курсов:</h2>

        <!--
            Это старый вариант фильтров для таблицы с Курсами.
        <form action="courses" method="GET">
            <div class="row">
                <div class="form-group col">
                    <label for="department">Кафедра:</label>
                    <select class="form-control" name="department" id="department" v-model="department_id">
                        <option value="-1" :selected="(this.$route.query.department == -1) || (!this.$route.query.department)">Все Кафедры</option>
                        <option v-for="item in data.departments" :key="item.id" :value="item.id" :selected="$route.query.department == item.id">{{ item.name }}</option>
                    </select>
                </div>
                <div class="form-group col">
                    <label for="name">Название:</label>
                    <input class="form-control" type="text" name="name" id="name" v-model="name">
                </div>
            </div>
            <input type="submit" value="Обновить">
        </form>
        -->
        
        <!-- Это для обновления без перезагрузки страницы: -->
        <!-- <button @click.prevent="loadRecords()">refresh</button> -->


        <!--
            Это старый вариант таблицы с Курсами.
        <Loader v-if="loading" />
        <div v-else-if="data.courses.length">
            <table class="table">
                <thead>
                    <tr>
                        <th>id</th>
                        <th>Наименование</th>
                        <th>Кафедра</th>
                        <th>Автор</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in data.courses" :key="item.id">
                        <td>{{ item.id }}</td>
                        <td>
                            <router-link :to="{ name: 'course_show', params: { id: item.id } }">{{ item.name }}</router-link>
                            <span v-if="item.status_id == 1" class="badge badge-info">в работе</span>
                            <span v-if="item.status_id == 5" class="badge badge-success">завершён</span>
                        </td>
                        <td>
                            <router-link :to="{ name: 'department_show', params: { id: item.department.id } }">{{ item.department.name }}</router-link>
                        </td>
                        <td>
                            <router-link :to="{ name: 'user_show', params: { id: item.user.id } }">{{ item.user.name }}</router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        -->

        <form action="courses" method="GET" class="mb-4">
            <div class="row d-flex align-items-end">
                <div class="form-group col-12 col-md-5">
                    <label for="department">Кафедра:</label>
                    <select class="form-control" name="department" id="department" v-model="department_id">
                        <option value="-1" :selected="(this.$route.query.department == -1) || (!this.$route.query.department)">Все Кафедры</option>
                        <option v-for="item in data.departments" :key="item.id" :value="item.id" :selected="$route.query.department == item.id">{{ item.name }}</option>
                    </select>
                </div>
                <div class="form-group col-12 col-md-5">
                    <label for="name">Название:</label>
                    <input class="form-control" type="text" name="name" id="name" v-model="name">
                </div>
                <div class="col-12 col-md-2 form-group ">
                    <button type="submit" class="custom-table__button">Поиск</button>
                </div>
            </div>
        </form>
        



        <div class="row justify-content-center">
        <Loader v-if="loading" />
        <CourseCard v-else v-for="course in data.courses" v-bind:key="course.id" v-bind:course="course" />
        </div>



        <!--
            НОВЫЙ вариант таблицы с курсами !!!!
        -->
        <!--
        <Loader v-if="loading" />
        <div v-else-if="data.courses.length">
            <table class="custom-table">
                <thead>
                    <tr class="custom-table__header">
                        <th class="custom-table__col--25">id</th>
                        <th>Наименование</th>
                        <th>Кафедра</th>
                        <th>Автор</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in data.courses" :key="item.id">
                        <td>{{ item.id }}</td>
                        <td>
                            <router-link :to="{ name: 'course_show', params: { id: item.id } }">{{ item.name }}</router-link>&nbsp;
                            <span v-if="item.status_id == 1" class="badge badge-info">в работе</span>
                            <span v-if="item.status_id == 5" class="badge badge-success">завершён</span>
                        </td>
                        <td>
                            <router-link :to="{ name: 'department_show', params: { id: item.department.id } }">{{ item.department.name }}</router-link>
                        </td>
                        <td>
                            <router-link :to="{ name: 'user_show', params: { id: item.user.id } }">{{ item.user.name }}</router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        -->
    
        


    </div>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/Loader'
import CoursesSlider1 from '@/components/CoursesSlider1'
import PageTitle from '@/components/PageTitle'
import TheCoursesMenu from '@/components/TheCoursesMenu'
import CourseCard from '@/components/CourseCard'
import QuoteTest from '@/components/QuoteTest'

export default {
    data() {
        return {
            loading: true,
            data: [],
            id: 0,
            name: '',
            department_id: -1,
            errors: {load: ''},
            title: 'Курсы',
        }
    },
    async mounted() {

       // это для фильтров:
        if (this.$route.query.department) {
            this.department_id = this.$route.query.department
        }
        else {
            this.department_id = -1;
        }
        if (this.$route.query.name) {
            this.name = this.$route.query.name
        }
        else {
            this.name = '';
        }
        // загрузка данных:
        this.loadRecords()



    },
    methods: {
        async loadRecords() {
            this.errors.load = ''
            try {
                this.loading = true
                let p = { department: this.department_id, name: this.name }
                //let response = await axios.get('courses', { params: this.$route.query})
                let response = await axios.get('courses', { params: p })
                this.data = response.data
                this.loading = false
            }
            catch (e) {
                this.errors.load = 'Ошибка при загрузке данных'
            }
        },



    },
    components: {
        Loader,
        CoursesSlider1,
        PageTitle,
        TheCoursesMenu,
        CourseCard,
        QuoteTest,
    }
}
</script>


<style scoped>
        .custom-table {
            width: 100%;
            overflow: hidden;
            border-collapse: collapse;
            border-radius: 30px;
            border-radius: 10px;
            box-shadow: 0 0  2px 1px #E4E7EB;         
        }


        .custom-table__col--10 {
            width: 10%;
        }

        .custom-table__col--25 {
            width: 25%;
        }
        
        .custom-table__col--50 {
            width: 50%;
        }

        .custom-table__col--75 {
            width: 75%;
        }


        .custom-table__header {
            border-radius: 10px;
            background-color: #F5F7FA;
        }
        .custom-table__header th {
            text-transform: uppercase;
            font-weight: 400;
            font-size: .8rem;
            color: #166086;
        }

        .custom-table th, .custom-table td {
            padding: 15px 20px;
            border-bottom: 1px solid hsl(214, 15%, 91%);
        }

        .custom-table__link {
            /* color: #0B4F71; */
        }
        .custom-table__button {
            width: 100%;
            color: #fff;
            background-color: #166086;
            padding: 6px 12px;
            border: none;
            border-radius: 10px;
        }

</style>
